import { render } from "./NIMAdminModal.vue?vue&type=template&id=e6427e9c"
import script from "./NIMAdminModal.vue?vue&type=script&lang=js"
export * from "./NIMAdminModal.vue?vue&type=script&lang=js"

import "./NIMAdminModal.vue?vue&type=style&index=0&id=e6427e9c&lang=scss"

import exportComponent from "/home/runner/work/rust-webserver/rust-webserver/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__